export default "__VITE_ASSET__lqe84SPt__"